// extracted by mini-css-extract-plugin
module.exports = {"sub":"fontScale_sub__PN1Es"};